export default function ArrowIcon() {
  return (
    <>
      <path
        d='M1.72003 0.966666L6.0667 5.31333C6.58003 5.82667 7.42003 5.82667 7.93336 5.31333L12.28 0.966667'
        strokeWidth='1.47473'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </>
  );
}
